// extracted by mini-css-extract-plugin
module.exports = {"ImageWrapper":"markdown-extended_ImageWrapper__YB6lv","AltText":"markdown-extended_AltText__GgweH"};